import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import AmazonAdsService from 'services/providers/AmazonAdsService';

const AmazonAdsAuthorize = props => {
    const [authUrl, setAuthUrl] = useState('');
    const history = useHistory();

    const getData = async () => {
        const r = await AmazonAdsService.getAuthUrl();

        if (r?.success && r?.url) {
            setAuthUrl(r.url);
        } else {
            alert("Amazon authorization failed.");
        }
    };

    useEffect(() => {
        if (authUrl) {
            window.location.href = authUrl;
        }
    }, [authUrl]);

    useEffect(async () => {
        await getData();
    }, []);

    return <></>;
};

export default AmazonAdsAuthorize;
